import { Modal, Col, Row, Space, Typography, Dropdown, message } from "antd";
import IncidentTypesFormDialog from "../components/IncidentTypesFormDialog";
import { useState } from "react";
import { Guid } from "guid-typescript";
import IncidentTypesView from "../components/IncidentTypesView";
import { SearchQuery } from "../code/search-query/search-query";
import { getIncidentTypesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { IncidentType } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function IncidentTypesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [incidentTypesInputMode, setIncidentTypesInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [incidentTypesInputOpen, setIncidentTypesInputOpen] = useState(false);
  const [incidentTypesInputValues, setIncidentTypesInputValues] =
    useState<IncidentType>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onIncidentTypeInputOpen(
    mode: "add" | "update" | "delete",
    values?: IncidentType,
  ): void {
    setIncidentTypesInputMode(mode);
    setIncidentTypesInputOpen(true);
    setIncidentTypesInputValues(values || ({} as any));
  }

  function onIncidentTypeInputFinish(): void {
    setIncidentTypesInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onIncidentTypeInputClose(): void {
    setIncidentTypesInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading incident-types export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getIncidentTypesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Incident Types
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("IncidentTypes", "create")}

            className={`${!permissions.can("IncidentTypes", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("IncidentTypes", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onIncidentTypeInputOpen("add")}
          >
            Add Incident Type
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <IncidentTypesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onIncidentTypeInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <IncidentTypesFormDialog
        mode={incidentTypesInputMode}
        open={incidentTypesInputOpen}
        initialValues={incidentTypesInputValues}
        onFinish={onIncidentTypeInputFinish}
        onCancel={onIncidentTypeInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default IncidentTypesPage;
